import { useContext, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { UserContext } from "../App";
import Boards from "./Boards";
import Games from "./Games";
import Ladder from "./Ladder";
import ThreeColumnPage from "./ui/ThreeColumnPage";
import Modal from "./ui/Modal";

const HomePage = () => {

    const [user] = useContext(UserContext);
    const [error, setError] = useState(undefined);
    const navigate = useNavigate();

    function handleError(error) {
        if (error.response && error.response.status === 401) {
            navigate("/logout");
        } else {
            setError(error);
        }
    }

    return (
        <>
            {!user && <Navigate to="/login" />}
            <ThreeColumnPage>
                <Ladder onError={handleError} />
                <Games onError={handleError} />
                <Boards onError={handleError} />
            </ThreeColumnPage>
            {error && <Modal text={error.message} onClose={() => setError(undefined)} />}
        </>
    );
}

export default HomePage;